import { Localization } from "../../../../../../OW.Remoting/Remoting/Localization";
import { DropDownMenuItem } from "../../../../../UI.Controls/DropDownMenu/DropDownMenuItem";
import { createElement, registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
//import { Caption } from '../../../Controls/Caption.js';

export class DropDownMenuCaptionItem extends DropDownMenuItem {
    private _secondCaptionElement: HTMLElement;

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    protected override _constructor(): void {
        super._constructor();

        //this.Priority = ;
        //this.locKey = locKey;
        this.visible = true;
        //if (subMenu) this.Submenu = subMenu;
    }

    public setCaptions(mainText: string, caption: string): void {
        if (mainText == undefined)
            this._captionElement.textContent = mainText;
        if (caption == undefined)
            this._secondCaptionElement.textContent = caption;
    }

    public async setCaptionsLocKey(mainTextLoc: string, captionLoc: string): Promise<void> {
        if (mainTextLoc) {
            Localization.addLocData(this._captionElement, mainTextLoc);
            //this.locKey = mainTextLoc;
        }
        if (captionLoc) {
            Localization.addLocData(this._secondCaptionElement, captionLoc);
            //this.locKey = captionLoc;
        }
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "SecondCaptionItem");
        const container = createElement({ type: "div", classes: "container" });
        this._secondCaptionElement = createElement({ type: "span", classes: "second-caption" });

        this._createCaptionElement();
        this._createIconElement();

        container.appendChild(this._captionElement);
        container.appendChild(this._secondCaptionElement);

        this.appendChild(this._iconElement);
        this.appendChild(container);
    }

    protected override _createCaptionElement(): void {
        this._captionElement = document.createElement("div");
        this._captionElement.classList.add("Caption");

        if (this._locKey) {
            Localization.addLocData(this._captionElement, this._locKey);
        }
    }

    protected override _setListener(): void {
        super._setListener();
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuCaptionItem", DropDownMenuCaptionItem);
